interface UpdateInfoProps {
  updated_at?: string;
  updated_by?: string;
}

const UpdateInfo = ({ updated_at, updated_by }: UpdateInfoProps) => {
  if (!updated_at && !updated_by) return null;

  const formatDate = (dateString: string) => {
    try {
      const date = new Date(dateString);
      return date.toLocaleString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    } catch (error) {
      return dateString;
    }
  };

  return (
    <div className="flex items-center gap-4 border-t border-gray-200 pt-2 text-xs text-gray-500">
      {updated_at && (
        <div>
          <span className="font-medium">Updated at:</span>{" "}
          {formatDate(updated_at)}
        </div>
      )}
      {updated_by && (
        <div>
          <span className="font-medium">Updated by:</span> {updated_by}
        </div>
      )}
    </div>
  );
};

export default UpdateInfo;
